import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import MyContext from '@/shared/contexts/AppContext';
import { CarregarPermissoes, ValidarPermissao, getLoginTokenFromStorage, isLogedIn, } from '@/modules/system/auth/application/auth.service';
import { Navigate, useNavigate } from 'react-router-dom';
import { RoleLevelDto } from '@/modules/system/auth/domain/role-level.dto';
import { useContext, useEffect, useState } from 'react';

interface ProtectedRouteProps {
  children: JSX.Element;
  /** @deprecated Mantido por compatibilidade; não restringe mais por módulo. */
  allowed?: unknown[];
  /** Uma permissão exigida ou lista de permissões (qualquer uma satisfaz). */
  permissao?: RoleLevelDto | RoleLevelDto[];
}

/**
 * Define que uma rota é protegida.
 */
export default function Protected({
  children,
  permissao,
}: ProtectedRouteProps) {
  const navigate = useNavigate();
  const context = useContext(MyContext);

  if (!context)
    throw new Error('DisplayComponent deve ser usado dentro de um MyProvider');
  const { sessionReady } = context;

  const TOKEN = getLoginTokenFromStorage();
  const [isNotLoggedIn] = useState(TOKEN === null || TOKEN === undefined);

  useEffect(() => {
    if (isNotLoggedIn) {
      navigate(`${Links.Auth_Login}`);
    }
  }, [isNotLoggedIn, navigate]);

  if (isLogedIn() && !sessionReady) {
    return <Loading />;
  }

  const permissoes = CarregarPermissoes();
  if (permissao) {
    const exigidas = Array.isArray(permissao) ? permissao : [permissao];
    const temAlguma = exigidas.some((p) => ValidarPermissao(permissoes, [p]));
    if (!temAlguma) {
      return <Navigate to={Links.Nao_Autorizado} replace />;
    }
  }

  if (!isNotLoggedIn) {
    return children;
  }
}
